import styled from "@emotion/styled"
import * as api from "api"
import ClampLines from "react-clamp-lines"
import Shared from "theme/shared"

const Styled = {
  Wrapper: styled.div`
    padding: 10px 15px;
  `,
  Headline: styled(Shared.Header)`
    text-align: left; // flipped for mui
    margin-top: 0;
  `,
  ClampedText: styled(ClampLines)`
    p {
      margin-bottom: 0;
    }
    button {
      color: ${(p) => p.theme.colors.marine};
      text-decoration: underline;
      background: none;
      border: none;
      appearance: none;
      box-shadow: none;
      font-size: 0.875rem;
      padding: 0;
    }
  `,
}

type AboutProps = { serviceCenter: api.SingleServiceCenter }

const About = ({ serviceCenter }: AboutProps) => {
  return (
    <Styled.Wrapper>
      <Styled.Headline variant="h2">קצת עלינו</Styled.Headline>
      {serviceCenter.description && (
        <Styled.ClampedText
          text={serviceCenter.description}
          id="serviceCenterDescription"
          lines={7}
          ellipsis="..."
          moreText="קרא עוד"
          lessText="קרא פחות"
          innerElement="p"
        />
      )}
    </Styled.Wrapper>
  )
}

export default About
